module.exports = __webpack_public_path__ + "img/happy-box.1f7af4f3.png";